 
import { useEffect } from 'react';
import scripts from 'scripts';

export default () => {
  useEffect(() => {
    scripts.map((item) => {
      const script = document.createElement('script');
      script.src = item.src;
      script.async = true;
      document.body.appendChild(script);
    });
  }, []);
};
